export default "__VITE_ASSET__CXpaVIWy__"